<template>
  <div>
    <headline :content="$t('project.project_information')">
      <div class="d-block w-100">
        <div class="d-flex justify-end mb-2">
        </div>
      </div>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div v-if="!isLoading && admins && admins[0] && admins[0].project">
          <v-container fluid>
            <v-row>
              <v-col>
                <v-card class=" box-project" elevation="0">
                  <v-card-title class="flex justify-space-between">
                    <div class="font-weight-bold">{{ $t('project.project_name_title', { name: admins[0].project.name })
                      }}</div>
                    <v-btn @click="editProjectName(admins[0].project)" class="ml-5" color="warning" elevation="0"
                      id="page-setting-info-btn-edit-project">
                      <v-icon class="mr-1">mdi-pencil</v-icon>{{ $t('project.edit_project') }}
                    </v-btn>
                    <div class="divider"></div>
                  </v-card-title>

                  <v-card-subtitle class="txt-sub-title">
                    <div class="d-flex justify-between mb-3">
                      <div>{{ $t('project.business_type') }} :
                        <span
                          v-if="projectDataById && projectDataById.setting && projectDataById.setting.bussinessType">{{
                            projectDataById.setting.bussinessType == 'personal' ? $t('project.business_type_personal') :
                          $t('project.business_type_company') }}</span>
                        <span v-else>{{ $t('not_specified') }}</span>
                      </div>
                      <div>{{ $t('project.show_price') }} : {{ admins[0].project.isVatInclusive ?
                        $t('project.show_price_inclusive_vat') : $t('project.show_price_exclusive_vat') }}</div>
                    </div>
                    <div class="d-flex justify-between">
                      <div>{{ $t('project.number_of_market_in_project', { count: admins.length }) }}</div>
                      <div>{{ $t('project.date_of_create_project', {
                        date: dateTimeFormat(admins[0].project.createdAt)
                        }) }}</div>
                    </div>
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h4 class="m-0 font-weight-bold">{{ $t('project.market_in_project', {
                  name: admins[0].project.name,
                  count: admins.length }) }}</h4>
              </v-col>
            </v-row>
            <v-row>
              <v-col lg="4" md="4" cols="12" v-for="(mk, inx) of marketByProject" :key="mk.objectId">
                <v-card class="box-market" elevation="0" v-if="mk">
                  <v-card-text>
                    <div class="txt-title mb-4">{{ $t('project.market_name', { name: mk.name }) }}</div>
                    <div class="txt-sub-title d-flex justify-between">
                      <div>{{ $t('project.business_type') }} :
                        <span v-if="mk.setting && mk.setting.bussinessType">{{ mk.setting.bussinessType == 'personal' ?
                          $t('project.business_type_personal') : $t('project.business_type_company') }}</span>
                        <span v-else>{{ $t('not_specified') }}</span>
                      </div>
                    </div>
                    <div class="txt-sub-title">{{ $t('project.date_of_create_market', {
                      date:
                        dateTimeFormat(mk.createdAt) }) }}</div>
                    <div>
                      <v-btn @click="editMarketName(mk)" elevation="0" block color="warning"
                        :id="`page-setting-info-btn-edit-market-${inx}`">
                        <v-icon class="mr-1">mdi-pencil</v-icon>{{ $t('project.edit_market') }}
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <v-card class="d-flex justify-center py-10" elevation="0" v-else>
          <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
        </v-card>
      </template>
    </layout>

    <v-dialog v-model="isChangeNameDialog" max-width="850" v-if="currentData" persistent scrollable>
      <v-form @submit.prevent="saveChangeName()" ref="form" :lazy-validation="true">
        <v-card>
          <v-card-title class="primary white--text py-2 d-flex justify-between">
            {{ $t('account.edit_data') }}{{ type == 'project' ? $t('project.title') : type == 'market' ?
              $t('market.market'):
            '-'}}
            <v-btn color="white" icon @click="isChangeNameDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-5">
            <v-row class="mt-3">
              <v-col cols="12" class="pb-0">
                <v-text-field v-model="tempName"
                  :placeholder="`${$t('name')}${type == 'project' ? $t('project.title') : type == 'market' ? $t('market.market') : '-'}`"
                  outlined dense background-color="white"
                  :label="`${$t('name')}${type == 'project' ? $t('project.title') : type == 'market' ? $t('market.market') : '-'}`"
                  :rules="[rules.required]" required hide-details
                  :id="`page-setting-info-name-${type}-input-data`"></v-text-field>
              </v-col>

              <v-col cols="12" class="py-0">
                <div class="d-flex justify-between align-center">
                  <div class="d-flex align-center">
                    <h4 class="me-2 grey--text text--darken-4"> {{ $t('project.business_type') }} : </h4>
                    <div>
                      <v-radio-group v-model="bussinessType" row :id="`bussinessType-${type}-input-data`">
                        <v-radio hide-details :label="$t('project.business_type_company')" value="company"
                          :id="`page-setting-info-bussinessType-${type}-input-data-1`"
                          :class="['border-default-radio me-2', { 'border-active-radio': bussinessType === 'company' }]"></v-radio>
                        <v-radio hide-details :label="$t('project.business_type_personal')" value="personal"
                          :id="`page-setting-info-bussinessType-${type}-input-data-2`"
                          :class="[`border-default-radio`, { 'border-active-radio': bussinessType === 'personal' }]"></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                  <h4 v-if="type == 'project'" class="me-2 grey--text text--darken-4"> {{ $t('tax.title') }} : {{
                    admins[0].project.isVatInclusive ? $t('project.show_price_inclusive_vat') :
                      $t('project.show_price_exclusive_vat') }} </h4>
                </div>
                <div class="divider-dash mb-2"></div>
              </v-col>
            </v-row>

            <template v-if="type == 'project'">
              <v-row>
                <v-col cols="12">
                  <div class="txt-title-green">{{ $t('project.date_of_create_bill_and_end_of_payment') }}</div>
                </v-col>
                <v-col cols="6">
                  <v-select v-model="billingDate" :items="getDayItems" item-text="name" item-value="value"
                    :placeholder="$t('project.date_of_create_bill_of_market')" dense outlined hide-details
                    :label="$t('project.date_of_create_bill_of_market')"
                    :id="`page-setting-info-date-create-bill-${type}-input-data`" :no-data-text="$t('noinfo')"/>
                </v-col>
                <v-col cols="6">

                  <v-select v-model="paymentEndDate" :items="getDayItems" item-text="name" item-value="value" dense
                    outlined hide-details :placeholder="$t('project.date_of_end_of_payment')"
                    :label="$t('project.date_of_end_of_payment')"
                    :id="`page-setting-info-end-date-payment-${type}-input-data`" :no-data-text="$t('noinfo')"/>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <div class="txt-title-green">{{ $t('project.email_contact_project') }}</div>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="email" :placeholder="`${$t('account.email')}`"
                    :label="`${$t('account.email')}`" outlined dense background-color="white" required type="email"
                    hide-details :id="`page-setting-info-email-project-input-data`" :rules="emailRules"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <div class="txt-title-green">{{ $t('project.phone_contact_project') }}</div>
                </v-col>
                <v-col cols="12 text-start py-0">
                  <div class="d-flex align-center justify-between">
                    <div>{{ $t('validate.please_add_phone_contact') }}</div>
                    <v-btn elevation="0" color="#42A5F5" class="white--text" @click="addTel()"
                      :id="`page-setting-info-btn-add-tel-no`" :disabled="isSaving">
                      <v-icon class="me-1">mdi-plus</v-icon> {{ $t('project.add_phone_contact') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-row class="">
                <template v-for="(item, inx) in tels">
                  <v-col cols="6" v-if="inx == 0" :key="`tel-${inx}`">
                    <v-text-field v-model="tels[inx]" :placeholder="`${$t('project.phone_contact')}`"
                      :label="`${$t('project.phone_contact')}`" outlined dense background-color="white" required
                      hide-details type="tel" :rules="[rules.minLength]" @keypress="numbersOnly" counter="10"
                      :id="`page-setting-info-phone-number-${type}-input-data-${inx}`"></v-text-field>
                  </v-col>
                  <v-col cols="6" v-else :key="`tels-${inx}`">
                    <v-text-field v-model="tels[inx]" :placeholder="`${$t('project.phone_contact')}`"
                      :label="`${$t('project.phone_contact')}`" outlined dense background-color="white" required
                      hide-details type="tel" :rules="[rules.minLength]" @keypress="numbersOnly" counter="10"
                      :id="`page-setting-info-phone-number-${type}-input-data-${inx}`">
                      <template #append-outer>
                        <img :src="require(`@/assets/images/icon-trash.svg`)" alt="Icon Trash"
                          class="icon-svg cursor-pointer" @click="removeTel(inx)" />
                      </template>
                    </v-text-field>
                  </v-col>
                </template>
              </v-row>
            </template>
            <!-- Address -->
            <v-row>
              <v-col cols="6">
                <div class="txt-title-green">{{ $t('project.address') }}</div>
              </v-col>
              <v-col v-if="type === 'market'" cols="6 text-end">
                <v-menu v-model="dropdownSettingByProjectMarket" :close-on-content-click="false" :close-on-click="false"
                  bottom left :offset-y="true" :max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" elevation="0" color="#42A5F5" class="white--text"
                      :id="`page-setting-info-btn-setting-by-project-market`">
                      {{ $t('project.get_address_from_project_or_market') }}
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <h4 class="grey--text text--darken-4">{{ $t('project.get_address_from_project_or_market') }}
                          </h4>
                          <div>{{ $t('project.set_location_by_project_or_market') }}</div>
                        </v-col>
                        <v-col lg="12" cols="12">
                          <v-select v-model="selectProjectMarketId" :items="selectProjectMarket" item-text="name"
                            item-value="objectId" chips dense outlined :return-object="true"
                            :id="`page-setting-info-select-by-project-market-input-data`" :no-data-text="$t('noinfo')">
                            <template v-slot:selection="data">
                              <v-chip :key="data.item.objectId" :input-value="data.selected" color="#E8F5E9"
                                text-color="#2E7D32" class="my-1">
                                {{ data.item.name }}
                              </v-chip>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" class="light me-2" @click="dropdownSettingByProjectMarket = false">
                        {{ $t('close') }}
                      </v-btn>
                      <v-btn class="success" text @click="getLocationBySelect">
                        {{ $t('confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="">
              <v-col cols="12">
                <v-text-field v-model="addressDetail"
                  :placeholder="`${$t('project.house_number_or_building_name_village')}`"
                  :label="`${$t('project.house_number_or_building_name_village')}`" outlined dense
                  background-color="white" required hide-details
                  :id="`page-setting-info-address-${type}-input-data`"></v-text-field>
              </v-col>

              <v-col lg="6" md="6" cols="12">
                <!-- <v-text-field
                  v-model="addressSubDistrict"
                  :placeholder="`ตำบล/แขวง`"
                  :label="`ตำบล/แขวง`"
                  outlined
                  dense
                  background-color="white"
                  required
                  hide-details
                  :id="`page-setting-info-subdistrict-${type}-input-data`"
                ></v-text-field> -->
                <div>{{ $t('address.sub_district_or_district') }}</div>
                <addressinput-subdistrict v-model="addressSubDistrict" outlined dense
                  :placeholder="`${$t('address.sub_district_or_district')}`"
                  :inputClass="`white rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
                  :id="`page-setting-info-subdistrict-${type}-input-data`" label="" />
              </v-col>

              <v-col lg="6" md="6" cols="12">
                <!-- <v-text-field
                  v-model="addressDistrict"
                  :placeholder="`อำเภอ/เขต`"
                  :label="`อำเภอ/เขต`"
                  outlined
                  dense
                  background-color="white"
                  required
                  hide-details
                  :id="`page-setting-info-district-${type}-input-data`"
                ></v-text-field> -->
                <div>{{ $t('address.amphoe_or_zone') }}</div>
                <addressinput-district v-model="addressDistrict" outlined dense
                  :placeholder="`${$t('address.amphoe_or_zone')}`"
                  :inputClass="`white rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
                  :id="`page-setting-info-district-${type}-input-data`" label="" />
              </v-col>
              <v-col lg="6" md="6" cols="12">
                <!-- <v-text-field
                  v-model="addressProvince"
                  :placeholder="`จังหวัด`"
                  :label="`จังหวัด`"
                  outlined
                  dense
                  background-color="white"
                  required
                  hide-details
                  :id="`page-setting-info-province-${type}-input-data`"
                ></v-text-field> -->
                <div>{{ $t('project.province') }}</div>
                <addressinput-province v-model="addressProvince" outlined dense
                  :placeholder="`${$t('project.province')}`"
                  :inputClass="`white rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
                  :id="`page-setting-info-province-${type}-input-data`" label="" />
              </v-col>
              <v-col lg="6" md="6" cols="12">
                <!-- <v-text-field
                  v-model="addressZipcode"
                  :placeholder="`รหัสไปรษณีย์`"
                  :label="`รหัสไปรษณีย์`"
                  outlined
                  dense
                  background-color="white"
                  required
                  hide-details
                  :id="`page-setting-info-zipcode-${type}-input-data`"
                ></v-text-field> -->
                <div>{{ $t('project.postal_code') }}</div>
                <addressinput-zipcode v-model="addressZipcode" outlined dense
                  :placeholder="`${$t('project.postal_code')}`"
                  :inputClass="`white rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
                  :id="`page-setting-info-zipcode-${type}-input-data`" label=""/>
              </v-col>
            </v-row>

            <!-- Position Location -->
            <v-row class="align-center mt-1">
              <v-col cols="6">
                <div class="txt-title-green">{{ $t('project.localtion') }}</div>
              </v-col>
              <v-col cols="6 text-end">
                <v-menu v-model="dropdownSettingMore" :close-on-content-click="false" :close-on-click="false" bottom
                  left :offset-y="true" :max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" elevation="0" class="white--text ps-0 pr-2" color="#42A5F5"
                      :id="`page-setting-info-btn-${type}-setting-location`" :disabled="isSaving">
                      <v-icon class="me-1">mdi-dots-vertical</v-icon> {{
                        $t('project.set_location_by_latitude_and_longitude') }}
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <h4 class="grey--text text--darken-4">{{ $t('project.set_location_by_latitude_and_longitude')
                            }}
                          </h4>
                          <div>{{ $t('project.setting_location_by_latitude_and_longitude') }}</div>
                        </v-col>
                        <v-col lg="12" cols="12">
                          <v-text-field v-model="latitude" :placeholder="`Latitude (${$t('project.latitude')})`"
                            :label="`Latitude (${$t('project.latitude')})`" outlined dense background-color="white"
                            hide-details :id="`page-setting-info-${type}-data-input-latitude`"></v-text-field>
                        </v-col>
                        <v-col lg="12" cols="12">
                          <v-text-field v-model="longitude" :placeholder="`Longitude (${$t('project.longitude')})`"
                            :label="`Longitude (${$t('project.longitude')})`" outlined dense background-color="white"
                            hide-details :id="`page-setting-info-${type}-data-input-longitude`"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" class="light me-2" @click="dropdownSettingMore = false">
                        {{ $t('close') }}
                      </v-btn>
                      <v-btn class="success" text id="page-setting-info-btn-submit-save-marker"
                        @click="saveMarker(latitude, longitude)">
                        {{ $t('confirm') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-alert color="#2196F3" dense text :width="325" style="border-left: 5px solid #2196F3;" class="mb-0"
                  :disabled="isSaving">
                  {{ $t('project.drag_or_click_to_set_market_location') }}
                </v-alert>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <div id="map">
                  <div v-if="isLoadingLocation || isSaving" class="loading-overlay">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </div>

                  <div class="custom-locate-button" @click="getCurrentLocation">
                    <img v-if="!isCurrentLocation" :src="require('@/assets/images/location-icon.png')" alt="">
                    <img v-else :src="require('@/assets/images/location-active-icon.png')" alt="">
                  </div>

                  <l-map ref="leafletMap" :key="mapKey" :zoom="mapOptions.zoom" :center="mapOptions.center"
                    style="height: 400px; width: 100%;" @update:zoom="updateZoom" @click="changeMarker">
                    <l-tile-layer :url="mapOptions.mapUrl" :attribution="mapOptions.attribution"></l-tile-layer>
                    <template v-if="markerProject.length">
                      <l-marker v-for="(marker, index) in markerProject" :key="marker.id" :draggable="marker.draggable"
                        :lat-lng.sync="marker.position" :icon="marker.icon"
                        @move="updateLatLng(marker.position.lat, marker.position.lng)"
                        @moveend="updateLatLng(marker.position.lat, marker.position.lng)" :zIndexOffset="1028">
                        <l-tooltip v-if="marker.tooltip" :options="{ direction: 'right', offset: [15, -20] }">
                          <div class="custom-tooltip-text">
                            {{ marker.tooltip }}
                          </div>
                        </l-tooltip>
                      </l-marker>
                    </template>
                    <template v-if="markerMarket.length">
                      <l-marker v-for="(marker, index) in markerMarket" :key="marker.id" :draggable="marker.draggable"
                        :lat-lng.sync="marker.position" :icon="marker.icon"
                        @move="updateLatLng(marker.position.lat, marker.position.lng)"
                        @moveend="updateLatLng(marker.position.lat, marker.position.lng)" :zIndexOffset="1">
                        <l-tooltip v-if="marker.tooltip" :options="{ direction: 'right', offset: [15, -20] }">
                          <div class="custom-tooltip-text">
                            {{ marker.tooltip }}
                          </div>
                        </l-tooltip>
                      </l-marker>
                    </template>
                  </l-map>
                </div>
              </v-col>
            </v-row>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :id="`page-setting-info-${type}-btn-save-data`" class="success" type="submit"
              :disabled="!tempName || isSaving" :loading="isSaving">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import Layout from "../../components/Layout";
import Headline from "../../components/Headline";
import { mapGetters, mapAction } from "vuex";
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LCircle } from 'vue2-leaflet';

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    Layout,
    Headline,
    LTooltip,
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    getDayItems() {
      const data = [];
      for (let i = 0; i < 31; i++) {
        data.push({
          name: `${this.$t('project.every_day_of_month', { date: i + 1 })}`,
          value: i + 1,
        })
      }
      return data;
    },
    selectProjectMarket() {
      const data = [];
      if (this.admins && this.admins[0]) {
        data.push({
          name: this.$t('project.according_to_the_project'),
          objectId: this.admins[0].project.objectId,
          type: "project"
        });
        this.admins.forEach((admin) => {
          if (admin.market) {
            data.push({
              name: admin.market.name,
              objectId: admin.market.objectId,
              type: "market"
            })
          }
        })
      }
      if (data.length > 0 && data) {
        return data.filter(a => a.objectId != this.currentData.objectId);
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      settingId: null,
      isLoading: false,
      isSaving: false,
      isChangeNameDialog: false,
      isCurrentLocation: false,
      isLoadingLocation: false,
      type: "",
      projectData: null,
      currentData: null,
      tempName: "",
      bussinessType: "personal",
      addressDetail: "",
      addressDistrict: "",
      addressSubDistrict: "",
      addressProvince: "",
      addressZipcode: "",
      defaultLatitude: 13.7563,
      defaultLongitude: 100.5018,
      tels: [""],
      email: null,
      paymentEndDate: null,
      menuEndDate: false,
      menuStartDate: false,
      billingDate: null,
      latitude: 13.7563,
      longitude: 100.5018,
      iconMarker: L.icon({
        iconUrl: require('@/assets/images/marker-icon.svg'),
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
      }),
      iconMarkerSub: L.icon({
        iconUrl: require('@/assets/images/marker-icon-sub.svg'),
        iconSize: [41, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
      }),
      mapOptions: {
        zoom: 12,
        center: [13.7563, 100.5018],
        mapUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '',
        currentZoom: 12,
      },
      markerProject: [],
      markerMarket: [],
      mapKey: 1,
      dropdownSettingMore: false,
      dropdownSettingByProjectMarket: false,
      selectProjectMarketId: null,
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        minLength: value => value.replace(/\D/g, "").length > 8 && value.replace(/\D/g, "").length <= 10 || this.$t('validate.please_input_phone_number_correct')
      },
      emailRules: [],
      projectDataById: null,
      marketByProject: null,
      marketData: null,
    };
  },
  created() {
    this.emailRules = [
      (value) => !!value || this.$t('validate.please_input_data'), // Check if the value exists
      (value) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || this.$t('validate.please_input_email_correct'), // Validate email format
    ];
  },
  mounted() {
    this.initData();
    this.$nextTick(() => {
      if (this.$refs.leafletMap) {
        this.$refs.leafletMap.mapObject.invalidateSize();
      }
    });
  },
  watch: {
    isChangeNameDialog(value) {
      if (!value) {
        this.type = "";
        this.currentData = null;
        this.tempName = "";
        this.tels = [""];
        this.latitude = this.defaultLatitude;
        this.longitude = this.defaultLongitude;
        this.marketData = null;
        this.settingId = null;
        this.selectProjectMarketId = null;
        this.mapOptions.currentZoom = 12;
        this.initData();
      }
    }
  },
  methods: {
    async initData() {
      try {
        this.projectDataById = await this.getProjectSettingById();
        this.marketByProject = await this.getMarketByProject();
      } catch (error) {
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    getProjectSettingById() {
      let data = null;
      data = this.$store.dispatch("project/getProject", { projectId: this.projectId });
      return data;
    },
    getMarketByProject() {
      let data = null;
      data = this.$store.dispatch("markets/getMarketByProject", this.projectId);
      return data;
    },
    getMarketById(id) {
      try {
        let data = null;
        data = this.$store.dispatch("markets/getMarket", { marketId: id });
        return data;
      } catch (error) {
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    async createMarketSetting(data) {
      try {
        let result = await this.$store.dispatch("marketSetting/createMarketSetting", data);
        return result
      } catch (error) {
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    editProjectName(project) {
      const marketByProject = this.marketByProject;
      const projectSetting = this.projectDataById;
      this.type = "project";
      this.currentData = project;
      this.tempName = project.name;
      this.isChangeNameDialog = true;
      this.isCurrentLocation = false;
      this.mapKey += 1;
      this.latitude = this.defaultLatitude;
      this.longitude = this.defaultLongitude;

      if (projectSetting.setting) {
        this.bussinessType = projectSetting.setting.bussinessType;
        this.addressDetail = projectSetting.setting.addressDetail || null;
        this.addressDistrict = projectSetting.setting.addressDistrict || null;
        this.addressProvince = projectSetting.setting.addressProvince || null;
        this.addressSubDistrict = projectSetting.setting.addressSubDistrict || null;
        this.addressZipcode = projectSetting.setting.addressZipcode || null;
        if (projectSetting.setting.geolocation) {
          this.latitude = projectSetting.setting.geolocation.latitude ? projectSetting.setting.geolocation.latitude : this.defaultLatitude;
          this.longitude = projectSetting.setting.geolocation.longitude ? projectSetting.setting.geolocation.longitude : this.defaultLongitude;
        }
        this.billingDate = projectSetting.setting.billingDate || null;
        this.paymentEndDate = projectSetting.setting.paymentEndDate || null;
        this.email = projectSetting.setting.email || null;
        this.tels = projectSetting.setting.tels && projectSetting.setting.tels.length > 0 ? projectSetting.setting.tels : [""];
        this.settingId = projectSetting.setting.objectId;
      } else {
        this.bussinessType = null;
        this.addressDetail = null;
        this.addressDistrict = null;
        this.addressProvince = null;
        this.addressSubDistrict = null;
        this.addressZipcode = null;
        this.billingDate = null;
        this.paymentEndDate = null;
        this.email = null;
        this.tels = [""];
        this.settingId = null;
      }
      this.markerProject = [{
        position: { lat: this.latitude, lng: this.longitude },
        draggable: true,
        tooltip: `${this.$t('project.project_name_title', { name: this.tempName })}`,
        icon: this.iconMarker,
      }];

      this.markerMarket = [];
      marketByProject.forEach((item, inx) => {
        if (item.setting && item.setting.geolocation && item.setting.geolocation.latitude && item.setting.geolocation.longitude) {
          this.markerMarket.push({
            position: { lat: item.setting.geolocation.latitude, lng: item.setting.geolocation.longitude },
            draggable: false,
            tooltip: `${this.$t('project.market_name', { name: item.name })}`,
            icon: this.iconMarkerSub,
          })
        }
      });

      this.$nextTick(() => {
        this.$refs.leafletMap.mapObject.setView([this.latitude, this.longitude], this.mapOptions.currentZoom);
        this.$refs.leafletMap.mapObject.invalidateSize();
      });
    },
    async editMarketName(market) {
      const marketById = this.marketByProject.find((item) => item.objectId == market.objectId);
      this.type = "market";
      this.currentData = market;
      this.tempName = market.name;
      this.isChangeNameDialog = true;
      this.isCurrentLocation = false;
      this.mapKey += 1;
      this.markerProject = [];
      this.latitude = this.defaultLatitude;
      this.longitude = this.defaultLongitude;
      if (marketById.setting) {
        this.bussinessType = marketById.setting.bussinessType || 'personal';
        this.addressDetail = marketById.setting.addressDetail || null;
        this.addressDistrict = marketById.setting.addressDistrict || null;
        this.addressProvince = marketById.setting.addressProvince || null;
        this.addressSubDistrict = marketById.setting.addressSubDistrict || null;
        this.addressZipcode = marketById.setting.addressZipcode || null;
        this.latitude = marketById.setting.geolocation ? marketById.setting.geolocation.latitude : this.defaultLatitude;
        this.longitude = marketById.setting.geolocation ? marketById.setting.geolocation.longitude : this.defaultLongitude;
        this.settingId = marketById.setting.objectId;
      } else {
        this.bussinessType = null;
        this.addressDetail = null;
        this.addressDistrict = null;
        this.addressProvince = null;
        this.addressSubDistrict = null;
        this.addressZipcode = null;

        let createMarketSetting = await this.createMarketSetting({
          marketId: market.objectId,
          bussinessType: null,
          addressDetail: null,
          addressProvince: null,
          addressDistrict: null,
          addressSubDistrict: null,
          addressZipcode: null,
          geolocation: { latitude: this.latitude, longitude: this.longitude }
        });
        if (createMarketSetting) {
          this.settingId = createMarketSetting.objectId;
        }
      }
      this.markerMarket = [{
        position: { lat: this.latitude, lng: this.longitude },
        draggable: true,
        tooltip: `${this.$t('project.market_name', { name: this.tempName })}`,
        icon: this.iconMarker,
      }];

      this.$nextTick(() => {
        this.$refs.leafletMap.mapObject.setView([this.latitude, this.longitude], this.mapOptions.currentZoom);
        this.$refs.leafletMap.mapObject.invalidateSize();
      });
    },
    async saveChangeName() {
      if (this.$refs.form.validate()) {
        if (this.type == "project" || this.type == "market") {
          try {
            this.isSaving = true;
            let tels = this.tels.filter(a => a);
            await this.$store.dispatch(
              this.type == "project"
                ? "project/updateProject"
                : "markets/updateMarket",
              {
                id: this.currentData.objectId,
                name: this.tempName,
              }
            );
            let formData = null;
            if (this.type == 'project') {
              formData = {
                id: this.settingId,
                bussinessType: this.bussinessType,
                addressDetail: this.addressDetail,
                addressProvince: this.addressProvince,
                addressDistrict: this.addressDistrict,
                addressSubDistrict: this.addressSubDistrict,
                addressZipcode: this.addressZipcode,
                billingDate: this.billingDate,
                paymentEndDate: this.paymentEndDate,
                email: this.email,
                tels: tels,
                geolocation: { latitude: parseFloat(this.latitude), longitude: parseFloat(this.longitude) }
              }
            } else if (this.type == 'market') {
              formData = {
                id: this.settingId,
                bussinessType: this.bussinessType,
                addressDetail: this.addressDetail,
                addressProvince: this.addressProvince,
                addressDistrict: this.addressDistrict,
                addressSubDistrict: this.addressSubDistrict,
                addressZipcode: this.addressZipcode,
                geolocation: { latitude: parseFloat(this.latitude), longitude: parseFloat(this.longitude) }
              }
            }
            await this.$store.dispatch(
              this.type == "project"
                ? "projectSetting/updateProjectSetting"
                : "marketSetting/updateMarketSetting", formData);
            await this.$store.dispatch("user/getUserInfo");
            this.isSaving = false;
            this.isChangeNameDialog = false;

            this.$toast.show({
              content: `${this.$t('save_data_success')}`,
              color: "success"
            });
          } catch (error) {
            this.isSaving = false;
            this.isChangeNameDialog = false;
            if (error?.response?.data?.error) {
              this.$toast.show({
                content: error.response.data.error,
                color: "error"
              });
            } else {
              this.$toast.show({
                content: error.message,
                color: "error"
              });
            }
          }
        }
      }
    },
    async getLocationBySelect() {
      let data = this.selectProjectMarketId;
      if (data.type == 'project') {
        const projectSetting = this.projectDataById;
        if (projectSetting.setting) {
          this.addressDetail = projectSetting.setting.addressDetail || null;
          this.addressDistrict = projectSetting.setting.addressDistrict || null;
          this.addressProvince = projectSetting.setting.addressProvince || null;
          this.addressSubDistrict = projectSetting.setting.addressSubDistrict || null;
          this.addressZipcode = projectSetting.setting.addressZipcode || null;
        } else {
          this.addressDetail = null;
          this.addressDistrict = null;
          this.addressProvince = null;
          this.addressSubDistrict = null;
          this.addressZipcode = null;
          this.settingId = null;
        }
      } else {
        const marketSetting = this.marketByProject.find((item) => item.objectId == data.objectId);
        if (marketSetting.setting) {
          this.addressDetail = marketSetting.setting.addressDetail || null;
          this.addressDistrict = marketSetting.setting.addressDistrict || null;
          this.addressProvince = marketSetting.setting.addressProvince || null;
          this.addressSubDistrict = marketSetting.setting.addressSubDistrict || null;
          this.addressZipcode = marketSetting.setting.addressZipcode || null;
        } else {
          this.addressDetail = null;
          this.addressDistrict = null;
          this.addressProvince = null;
          this.addressSubDistrict = null;
          this.addressZipcode = null;
        }
      }
      this.dropdownSettingByProjectMarket = false
    },
    fullNameFormat(user) {
      let text = "-";
      if (user) text = `${user.firstName || ""} ${user.lastName || ""}`;
      return text;
    },
    dateTimeFormat(date, format = "DD MMM YYYY, HH:mm") {
      let text = "-";
      if (date && date.iso) {
        text = this.$moment(date.iso).format(format);
      } else if (date) {
        text = this.$moment(date).format(format);
      }
      return text;
    },
    getCurrentLocation() {
      this.isLoadingLocation = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            this.latitude = latitude;
            this.longitude = longitude;
            this.mapOptions.center[0] = latitude;
            this.mapOptions.center[1] = longitude;

            const marker = {
              position: { lat: latitude, lng: longitude },
              draggable: true,
              tooltip: "",
              icon: this.iconMarker,
            };
            if (this.type == "project") {
              this.markerProject[0] = marker;
            } else {
              this.markerMarket[0] = marker;
            }
            this.isCurrentLocation = true;
            this.$refs.leafletMap.mapObject.setView([latitude, longitude], this.mapOptions.currentZoom);
            this.isLoadingLocation = false;
          },
          (error) => {
            console.error("Error getting location:", error.message);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    saveMarker(latitude, longitude) {
      this.latitude = latitude;
      this.longitude = longitude;
      this.mapOptions.center[0] = latitude;
      this.mapOptions.center[1] = longitude;
      this.$refs.leafletMap.mapObject.setView([this.latitude, this.longitude], this.mapOptions.currentZoom);
      if (this.type == "project") {
        this.markerProject[0].position = { lat: latitude, lng: longitude };
      } else {
        this.markerMarket[0].position = { lat: latitude, lng: longitude };
      }
      this.dropdownSettingMore = false;
    },
    changeMarker(event) {
      this.latitude = event.latlng.lat;
      this.longitude = event.latlng.lng;
      this.mapOptions.center[0] = event.latlng.lat;
      this.mapOptions.center[1] = event.latlng.lng;
      if (this.type == "project") {
        this.markerProject[0].position = { lat: event.latlng.lat, lng: event.latlng.lng };
      } else {
        this.markerMarket[0].position = { lat: event.latlng.lat, lng: event.latlng.lng };
      }
      this.$refs.leafletMap.mapObject.setView([this.latitude, this.longitude], this.mapOptions.currentZoom);
    },
    updateLatLng(latitude, longitude) {
      this.latitude = latitude;
      this.longitude = longitude;
    },
    updateZoom(zoom) {
      this.mapOptions.currentZoom = zoom;
    },
    removeMarker: function (index) {
      if (this.type == "project") {
        this.markerProject.splice(index, 1);
      } else {
        this.markerMarket.splice(index, 1);
      }
    },
    addTel() {
      this.tels.push("");
    },
    removeTel: function (index) {
      this.tels.splice(index, 1);
    },
    formatTel(event, index) {
      let value = event;
      value = value.replace(/\D/g, "");
      if (value.length > 3 && value.length <= 6) {
        value = `${value.slice(0, 3)}-${value.slice(3)}`;
      } else if (value.length > 6) {
        value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 10)}`;
      }
      this.$set(this.tels, index, value);
    },
    numbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var input = evt.target || evt.srcElement;
      if (input.value.length >= 10) {
        evt.preventDefault();
        return false;
      }
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57)
      ) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
  }
};
</script>

<style scoped lang="scss">
#map {
  height: 100%;
  width: 100%;
  position: relative;

  .custom-locate-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: white;
    border: 1px solid #fff;
    padding: 5px;
    cursor: pointer;
    border-radius: 5px;
    box-shadow: 0px 12px 44px 0px #0000001F;
    z-index: 1000;

    /* Ensure it’s above map elements */
    img {
      width: 20px;
      height: 20px;
    }
  }
}

.leaflet-tooltip {
  position: absolute;
  padding: 6px;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #000000;
  font-weight: bold;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  pointer-events: none;
}

.leaflet-control-locate {
  display: block !important;
  visibility: visible !important;
}

.border-default-radio {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #ECEDF6;
}

.border-active-radio {
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--v-darkprimary_2-base) !important;
}

.divider-dash {
  height: 1px;
  width: 100%;
  border: 1px dashed #9E9E9E;
}

.box-project {
  background-color: #fff;
  border: 1px solid var(--v-darkprimary_2-base) !important;
  box-shadow: 0px 12px 44px 0px #0000001F !important;

  .divider {
    height: 1px;
    width: 100%;
    display: inline-block;
    background-color: #D3DCE0;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .txt-sub-title {
    font-size: 16px;
  }
}

.box-market {
  border-left: 5px solid var(--v-darkprimary_2-base);
  border-top: 2px solid var(--v-darkprimary_2-base);
  border-bottom: 2px solid var(--v-darkprimary_2-base);
  border-right: 2px solid var(--v-darkprimary_2-base);

  .txt-title {
    color: #000;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  .txt-sub-title {
    font-size: 16px;
    font-weight: 400;
    color: #777777;
    margin-bottom: 15px;
  }
}

.txt-title-green {
  font-size: 20px;
  font-weight: 700;
  color: #2E7D32;
}

.rotate-icon {
  transform: rotate(-35deg);
  margin-top: -6px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999999;
  background: #3333338c;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="scss">
.leaflet-tooltip.custom-tooltip-text {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: var(--v-darkprimary_2-base);
  font-size: 14px;
}

.th-address {
  position: relative;
  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

  .th-address-label {
    .label-text {
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 1;
      color: rgba(0, 0, 0, 0.6);
      font-size: 16px;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      transform-origin: top left;
      background-color: #fff;
    }
  }

  &:focus-within {
    .label-text {
      transform: translateY(-16px) scale(0.75);
      padding: 0 5px;
      color: var(--v-primary-base);
    }

    .th-address-input {
      border: 2px solid var(--v-primary-base) !important;

      &::placeholder {
        opacity: 1;
      }
    }
  }

  &:not(:placeholder-shown) {
    .label-text {
      transform: translateY(-16px) scale(0.75);
      padding: 0 5px;
      color: rgba(0, 0, 0, 0.6);
    }

    .th-address-input {
      border: 1px solid #a8a8a8 !important;

      &::placeholder {
        opacity: 1;
      }
    }
  }

  .th-address-input {
    border: 1px solid #a8a8a8 !important;
    padding: 8px 10px 8px;
    max-width: 100%;
    min-width: 0px;
    width: 100%;
    height: 40px;
    color: #000;
    font-size: 16px;

    &::placeholder {
      opacity: 1;
    }
  }
}

.th-address-autocomplete {
  background-color: #fff !important;
  border: 1px solid #a8a8a8 !important;
  padding: 10px !important;
  z-index: 1000 !important;
}

.leaflet-control-attribution.leaflet-control {
  display: none;
}
</style>